/**
 * @file 进度条
 * @author liuhanwei
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ProgressProps } from './interface';
import LineProgress from './LineProgress';
import CircleProgress from './CircleProgress';
import SizeContext from '../config-provider/SizeContext';
import { ConfigContext } from '../config-provider';
import { sizeRatioMap, statusColorMap, isHexColor, isNumber } from './common';
const Progress = (_a) => {
    var { percent: customizePercent = 0, type = 'line', size: customizeSize = 'middle', status: customizeStatus = 'active', strokeColor: customizeStrokeColor, textColor: customizeTextColor, textSize: customizeTextSize, successStyle = {}, format, prefixCls: customizePrefixCls } = _a, restProps = __rest(_a, ["percent", "type", "size", "status", "strokeColor", "textColor", "textSize", "successStyle", "format", "prefixCls"]);
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('progress', customizePrefixCls);
    const defaultSize = useContext(SizeContext) || 'small';
    // size取值异常时，将使用全局size或默认值small
    const size = customizeSize in sizeRatioMap ? customizeSize : defaultSize;
    // percent取值异常时，将使用默认值0
    const percent = isNumber(customizePercent) ? customizePercent : 0;
    // status取值异常时，将使用默认值active
    const status = customizeStatus in statusColorMap ? customizeStatus : 'active';
    // strokeColor取值异常时，将使用status对应的颜色
    let strokeColor = isHexColor(customizeStrokeColor)
        ? customizeStrokeColor
        : '';
    let iconStrokeColor = strokeColor || statusColorMap[status];
    // 解构进度100时的样式
    const { strokeColor: successStrokeColor, textColor: successTextColor, textSize: successTextSize } = successStyle;
    let textColor = customizeTextColor;
    let textSize = customizeTextSize;
    // 当进度100时，若存在完成时的样式，则使用该样式
    if (percent === 100) {
        strokeColor = isHexColor(successStrokeColor) ? successStrokeColor : strokeColor;
        textColor = isHexColor(successTextColor) ? successTextColor : textColor;
        textSize = isNumber(successTextSize) ? successTextSize : textSize;
    }
    // 若存在format方法，则格式化文本
    const labelText = format instanceof Function ? format(percent) : `${percent}%`;
    const props = { percent, size, status, strokeColor, iconStrokeColor, textColor, textSize, labelText, prefixCls };
    return (type === 'circle'
        ? <CircleProgress {...props} {...restProps}/>
        : <LineProgress {...props} {...restProps}/>);
};
export { ProgressProps };
export default Progress;
